import { createSubscriber, IEvent, IConsumer, createConsumer } from '@cian/events-log';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/types/redux';
import { getUser } from 'shared/thunks/user';

interface IViewData {
  headingType: string | undefined;
}

export interface IRequestAuthenticationParameters {
  viewData?: IViewData;
  onSuccess?(): void;
  onCloseNoAuth?(): void;
}

const TOPIC_USER = 'user';

type TConsumerSingleton = (() => IConsumer) & { _instance?: IConsumer };

const getUserConsumer: TConsumerSingleton = (): IConsumer => {
  if (!getUserConsumer._instance) {
    getUserConsumer._instance = createConsumer({ topic: TOPIC_USER });
  }

  return getUserConsumer._instance;
};

export const requestAuthentication = createAsyncThunk<void, IRequestAuthenticationParameters | undefined, IThunkApi>(
  'user/requestAuthentification',
  async (parameters, { dispatch, extra }) => {
    if (typeof window !== 'undefined') {
      const { microfrontendsAPI } = extra;

      if (!microfrontendsAPI) {
        return;
      }

      const consumer = getUserConsumer();

      const userSubscriber = createSubscriber(async (event: IEvent<unknown>) => {
        if (event.type === 'authenticated') {
          await dispatch(getUser());

          if (window.__reloadHeader__) {
            window.__reloadHeader__();
          }

          if (parameters && parameters.onSuccess) {
            parameters.onSuccess();
          }

          consumer.unsubscribe(userSubscriber);

          return;
        }

        if (event.type === 'authentication_modal_closed') {
          if (parameters && parameters.onCloseNoAuth) {
            parameters.onCloseNoAuth();
          }

          consumer.unsubscribe(userSubscriber);
        }
      });

      consumer.subscribe(userSubscriber);

      void microfrontendsAPI.header.openAuthModal({
        alert: null,
        autoRefresh: false,
        source: null,
        useDefaultView: false,
        viewData: parameters?.viewData || {},
      });
    }
  },
);
